import type { ReactElement } from 'react';

export function Splash(): ReactElement {
  return (
    <main className="min-h-screen bg-bg text-ink flex items-center justify-center">
      <div className="text-center">
        <h1 className="font-semibold tracking-tight text-4xl text-primary mb-2">ChitDesk</h1>
        <p className="font-sans text-sm text-ink/60">Loading…</p>
      </div>
    </main>
  );
}
